export default Object.freeze({
  // MEMBER_GRADE_
  TITLE: '회원등급 관리',

  DESCRIPTION_TITLE: '회원등급우선순위',
  DESCRIPTION_LINE_0: '기본등급을 중심으로 상위등급의 우선순위를 조정할 수 있습니다.',
  DESCRIPTION_LINE_1: '기본등급은 가장 낮은 등급으로써 우선순위 조정 및 삭제/등급평가조건 설정이 제한됩니다.',
  DESCRIPTION_LINE_2: '두 개 이상의 등급평가조건이 중복되는 등급이 있는 경우 우선순위에 따라 회원등급이 적용됩니다.',
  DESCRIPTION_LINE_3: '두 개 이상의 등급에 만족하는 회원의 경우 우선순위가 높은 등급으로 적용됩니다.',
  DESCRIPTION_LINE_4: '등급리스트에서 상단에 위치할수록 우선순위가 높은 등급입니다.',
  DESCRIPTION_LINE_5: '등급 사용여부가 ‘사용 안 함’ 이어도 ‘사용함’ 등급보다 우선순위가 높으면 우선으로 적용됩니다.',

  SETTING: '회원등급 설정',
  BTN_EVALUATION_SETTING: '등급평가설정',
  BTN_ADD: '등급추가',
  HINT_GRADES_EMPTY: '회원등급을 생성 해 주세요.',
  TITLE_NAME: '등급명',
  TITLE_NUM: '회원수',

  DETAIL_NO: '등급 번호',
  DETAIL_SETTING_TITLE: '등급 상세설정',
  DETAIL_NAME: '등급 이름',
  DETAIL_DESCRIPTION: '등급 설명',
  DETAIL_USED: '등급 사용여부',
  DETAIL_UNUSED: '사용 안 함',
  DETAIL_EVALUATION_CONDITION: '등급 평가 조건',
  DETAIL_BUY_PRICE: '구매 금액',
  DETAIL_BUY_COUNT: '구매 회수 ',
  EVALUATION_TYPE_PAY_AMT: '구매금액',
  EVALUATION_TYPE_PAY_CNT: '구매횟수',
  EVALUATION_TYPE_AMT_AND_CNT: '구매금액 and 구매횟수',
  EVALUATION_TYPE_AMT_OR_CNT: '구매금액 or 구매횟수',
  DETAIL_EVALUATION_DESP: '현재 {0} 기준으로 설정되어 있습니다.',
  ERR_RESERVE_RATE: '입력형식이 잘못되었습니다.',
  DETAIL_TIER_POINTS: '등급 적립금',
  DETAIL_AUTO_PAYMENT_SETTING: '자동지급 설정',
  DETAIL_AUTO_USED: '사용함',
  DETAIL_AMOUNT_PLACEHOLDER: '적립금 입력',
  DETAIL_OVER_MAX: '999,999,900 이하로 입력해주세요.',
  DETAIL_AUTO_ISSUE: '적립금 지급',
  DETAIL_AUTO_TYPE_NONE: '선택',
  DETAIL_AUTO_TYPE_ONCE: '1회지급',
  DETAIL_AUTO_TYPE_MONTHLY: '매월지급',
  DETAIL_AUTO_DESCRIPTION_1: '‘매월지급’ 선택 시 매월 등급조정일에 해당 회원등급 회원을 대상으로 적립금이 지급됩니다.',
  DETAIL_AUTO_DESCRIPTION_2: '‘1회지급’ 선택 시 매월 등급조정일에 해당 회원등급으로 조정된 회원을 대상으로 1회 적립금이 지급됩니다.',
  DETAIL_AUTO_DESCRIPTION_3: '자동 등급평가 사용여부에 따라 ‘사용 안 함‘일 경우 자동지급 적립금이 지급되지 않습니다.',
  DETAIL_AUTO_DESCRIPTION_NOT_USED: '현재 자동 등급평가 ‘사용 안 함’으로 설정되어 있습니다.',
  DETAIL_COUPON: '등급 쿠폰 혜택',
  DETAIL_SELECT_COUPON: '쿠폰검색',
  PROMOTION_CODE: '쿠폰번호',
  COUPON_NAME: '쿠폰명',
  ISSUE_TYPE_LABEL: '발급유형',
  DISCOUNT_AMT: '할인금액',
  POPUP_TITLE: '쿠폰 선택',
  DETAIL_POINT_SETTING: '등급 적립금 혜택',
  DETAIL_POINT: '적립',
  ERR_RESERVE_RATE_100: '100 이하로 입력해주세요.',

  BTN_SETTING: '변경사항 저장',

  ERR_GRADE_NAME_NULL: '등급 이름이 지정되지 않았습니다.',
  ERR_MINIMUM_NULL: '{0} 등급의 등급조건이 입력되지 않았습니다.',
  ERR_AMOUNT_NULL: '등급 적립금 자동지금 설정이 지정되지 않았습니다.',
  ERR_AMOUNT_ZERO: '등급 적립금 자동지급 설정의 적립금을 0보다 크게 입력해주세요.',
  ERR_AUTO_TYPE: '등급유지기간 기준 지급방식을 선택해주세요.',
  ERR_RESERVE_RATE_NULL: '등급 적립금 혜택이 지정되지 않았습니다',
  ERR_RESERVE_RATE_ZERO: '등급 적립금 혜택을 0%보다 크게 입력해주세요.',
  ERR_USED_ZERO: '하나의 등급은 사용중이여야 합니다.',
  ERR_HAVE_MEMBER: '회원이 등록된 회원등급은 삭제할 수 없습니다.',
  ERR_DEL_BASE: '기본회원등급은 삭제할 수 없습니다.',
  COMFIRM_BEFORE_MODIFY: '변경 된 내용을 저장하시겠습니까?',
  COMFIRM_DELETE_GRADE: '등록된 회원등급을 삭제하시겠습니까?',
  ALERT_SAVE: '변경사항이 저장 되었습니다.',
  COMFIRM_MOVE: '변경한 내용을 저장하고 이동하시겠습니까?',

  ALERT_ITEM_UP: '기본 등급은 이동할 수 없습니다',
  ALERT_ITEM_DOWN: '기본 등급으로 이동할 수 없습니다',

  DETAIL_NEW_GRADE_NAME: '새 등급명',
  DETAIL_NEW_GRADE_NO: '회원등급 저장 시 번호가 할당됩니다.',
});
